module.exports = __webpack_public_path__ + "img/agrbg.c4c86dec.jpg";